import { PlayerService } from "./PlayerService";

type checkAnswerResponse = {
    correct: boolean;
};

export class WordleService {
    private _playerService: PlayerService = new PlayerService();

    public async checkIfWordIsValid(word: string): Promise<boolean> {
        const response: Response = await fetch(`${VITE_API_URL}eva/check-word/${word}`,
            {
                method: "GET",
                headers: {
                    "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
                },
            }
        );

        const data: checkAnswerResponse = await response.json() as checkAnswerResponse;

        return data.correct;
    }

    public async checkIfWordIsCorrect(word: string): Promise<boolean> {
        const response: Response = await fetch(`${VITE_API_URL}eva/check-word-correct/${word}`,
            {
                method: "GET",
                headers: {
                    "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
                },
            }
        );

        const data: checkAnswerResponse = await response.json() as checkAnswerResponse;

        return data.correct;
    }
}
